import focusTrap from './focusTrap'

const redirectWithParamOnClick = (element, param) => {
  element.addEventListener('click', (event) => {
    event.preventDefault()
    window.location = element.href + param
  })
}

function addWidgetParamOnLinkClick(baseElement = document) {
  const links = baseElement.querySelectorAll('a')
  links.forEach((link) => {
    const hrefAttribute = link.getAttribute('href')
    if (hrefAttribute) {
      if (
        // eslint-disable-next-line no-script-url
        hrefAttribute.startsWith('javascript:') ||
        hrefAttribute.startsWith('#') ||
        hrefAttribute.startsWith('mailto:') ||
        hrefAttribute.startsWith('tel:') ||
        link.getAttribute('target') === '_blank'
      ) {
        return
      }

      if (link.classList.contains('fn-attachment')) {
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'noopener noreferrer')
      } else if (link.href.startsWith('/') || link.hostname === window.location.hostname) {
        if (link.href.includes('?')) {
          redirectWithParamOnClick(link, '&widget')
        } else {
          redirectWithParamOnClick(link, '?widget')
        }
      } else { // external link
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'noopener noreferrer')
      }

      if (link.classList.contains('no-external-icon')) {
        link.removeAttribute('target', '_blank')
      }
    }
  })
}

function widget() {
  // Redirect and remove widget URL if not in iframe
  if (window.top === window.self && 'URLSearchParams' in window) {
    const params = new URLSearchParams(window.location.search)
    let search = ''
    params.delete('widget')
    if (params.toString()) {
      search = `?${params.toString()}`
    }
    window.location = `${window.location.pathname}${search}`
  }

  const headerElement = document.querySelector('.header')
  const knowledgeNameElement = document.querySelector('.knowledge-name')
  const contentScrollableElement = document.querySelector('.fn-content-wrapper')
  const contentElement = document.querySelector('#content')
  const instantSearchElement = document.querySelector('[data-fn-instant-search')
  const backButton = document.getElementById('widget-back-button')
  const closeButton = document.getElementById('widget-close-button')
  const searchInput = document.querySelector('#search')

  const safeBuffer = 20
  const scrollBreakPoint = 10

  let fullHeaderHeight
  let minimizedHeaderHeight
  let maxContentArea
  let contentHeight

  function userIsSearching() {
    if (
      searchInput !== document.activeElement
      && document.querySelector('.fn-search-form button') !== document.activeElement
      && searchInput.value === ''
      && instantSearchElement.innerHTML === ''
    ) {
      return false
    }
    return true
  }

  function calculateHeights() {
    fullHeaderHeight = headerElement.querySelector('.top-area').getBoundingClientRect().height

    minimizedHeaderHeight = (
      (knowledgeNameElement.getBoundingClientRect().top * 2)
      + knowledgeNameElement.getBoundingClientRect().height
      + -scrollBreakPoint
    )

    maxContentArea = (
      document.body.getBoundingClientRect().height + -minimizedHeaderHeight + safeBuffer
    )

    contentHeight = contentElement.getBoundingClientRect().height
  }

  function setHeights() {
    if (contentScrollableElement.scrollTop > 2) {
      headerElement.classList.add('header--box-shadow')
    } else {
      headerElement.classList.remove('header--box-shadow')
    }

    if (
      (maxContentArea < contentHeight)
      && !userIsSearching()
      && (contentScrollableElement.scrollTop > scrollBreakPoint)
    ) {
      headerElement.style.maxHeight = `${minimizedHeaderHeight}px`
      contentScrollableElement.style.top = `${minimizedHeaderHeight}px`
      headerElement.classList.add('header--minimized')
    } else {
      headerElement.style.maxHeight = `${fullHeaderHeight}px`
      contentScrollableElement.style.top = `${fullHeaderHeight}px`
      headerElement.classList.remove('header--minimized')
    }
  }

  searchInput.addEventListener('focus', setHeights)
  document.querySelector('.fn-search-form button').addEventListener('focus', setHeights)

  window.addEventListener('load', () => {
    calculateHeights()
    setHeights()

    setTimeout(() => {
      const widgetRoot = document.querySelector('.wrapper')
      focusTrap(widgetRoot) // focus trap for widget
    }, 1000);
  }) 

  window.addEventListener('resize', () => {
    calculateHeights()
    setHeights()
  })

  contentScrollableElement.addEventListener('scroll', () => {
    contentHeight = contentElement.getBoundingClientRect().height
    setHeights()
  })

  calculateHeights()
  setHeights()
  addWidgetParamOnLinkClick()

  if (backButton) {
    backButton.addEventListener('click', () => {
      const prevPage = window.location.href
      const fallbackUrl = '/?widget'

      window.history.back()

      window.setTimeout(() => {
        if (window.location.href === prevPage) {
          window.location.href = fallbackUrl
        }
      }, 1000)
    })
  }

  closeButton.addEventListener('click', () => {
    window.parent.postMessage('close-kundo-knowledge-widget', '*')
  })

  const chatLinks = document.querySelectorAll('.contact-channel__link[data-type="chat"]')
  chatLinks.forEach((chatLink) => {
    chatLink.addEventListener('click', () => {
      window.parent.postMessage({ type: 'start-kundo-chat', flow: chatLink.attributes['data-value'].value }, '*')
      return false
    })
  })

  window.addEventListener('message', (event) => {
    const message = event.data

    if (message === 'kundo-knowledge-widget-iframe-loaded') {
      document.querySelector('.wrapper').setAttribute('tabindex', '-1')
      document.querySelector('.wrapper').focus()
    }
  })

  document.addEventListener('keydown', (event) => {
    if (
      (event.key === 'Escape' || event.keyCode === 27)
      && !document.querySelector('.modal[open]')
      && !userIsSearching()
    ) {
      window.parent.postMessage('close-kundo-knowledge-widget', '*')
    }
  })
}

export {
  addWidgetParamOnLinkClick,
  widget,
}
